import React, { useState } from 'react';
import { Sparkles, Loader2, ChevronDown, ChevronUp } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ArticleAiDraft = ({ token, category, onDraft }) => {
  const [open, setOpen] = useState(false);
  const [sujet, setSujet] = useState('');
  const [motsCles, setMotsCles] = useState('');
  const [consignes, setConsignes] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generate = async () => {
    if (sujet.trim().length < 5) return setError('Décrivez le sujet en quelques mots (5 caractères min.).');
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_URL}/api/admin/ai/article-draft`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ sujet, category, mots_cles: motsCles || null, consignes: consignes || null }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Erreur génération IA');
      onDraft(data);
      setOpen(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const input = 'w-full bg-[#1a1c1b] border border-[#3f4816] rounded-lg px-3 py-2 text-sm text-[#dfddd6] focus:border-[#d9fb06] focus:outline-none';

  return (
    <div className="bg-[#1a1c1b] border border-[#d9fb06]/40 rounded-xl mb-6" data-testid="article-ai-draft">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-3 text-left" data-testid="article-ai-toggle">
        <span className="flex items-center gap-2 text-[#d9fb06] font-bold text-sm uppercase"><Sparkles size={16} /> Rédiger un brouillon avec l'IA</span>
        {open ? <ChevronUp size={16} className="text-[#888680]" /> : <ChevronDown size={16} className="text-[#888680]" />}
      </button>
      {open && (
        <div className="p-3 pt-0 space-y-3">
          <input value={sujet} onChange={(e) => setSujet(e.target.value)} placeholder="Sujet de l'article (ex : Les 7 vérifications avant d'acheter un voilier d'occasion)" className={input} data-testid="article-ai-sujet" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input value={motsCles} onChange={(e) => setMotsCles(e.target.value)} placeholder="Mots-clés SEO (optionnel)" className={input} data-testid="article-ai-keywords" />
            <input value={consignes} onChange={(e) => setConsignes(e.target.value)} placeholder="Consignes (ton, angle, longueur…) — optionnel" className={input} data-testid="article-ai-consignes" />
          </div>
          {error && <p className="text-red-300 text-xs" data-testid="article-ai-error">{error}</p>}
          <div className="flex items-center gap-3">
            <button type="button" onClick={generate} disabled={loading} className="flex items-center gap-2 bg-[#d9fb06] text-[#1a1c1b] px-4 py-2 rounded-full text-sm font-bold hover:bg-[#c4e205] disabled:opacity-50" data-testid="article-ai-generate">
              {loading ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />}
              {loading ? 'Rédaction en cours (20-40 s)…' : 'Générer le brouillon'}
            </button>
            <span className="text-xs text-[#888680]">Remplit titre, extrait, contenu et mots-clés — relisez avant publication.</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArticleAiDraft;
